import { Component, OnDestroy, AfterContentInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActionDefinitionDTO, ProcurementProjectDTO, UnitPriceDTO, UnitPricesFilterDTO } from '../../api/plyca-dtos-v2';

import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { FormConfig } from '../../components/forms/form.objects';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { CodeInclusionDTO } from './model/codeInclusion.model';
import { TaskHandler } from '../TaskHandler';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { PropertyService } from '../../properties/property.service';
import { catchError, tap } from 'rxjs/operators';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { FieldConfig } from '../../api/contract-notice-dto';
import * as lodash from 'lodash';


export class CodeInclusionModel {
  dto: CodeInclusionDTO;
  ui: {
    awardDescription: string;
    contractDescription: string;
    taskProcurementProject: ProcurementProjectDTO;
  };
}

@Component({
  selector: 'codeinclusion',
  templateUrl: 'codeInclusion.template.html',
  providers: [DialogService, UIService]
  //  providers: [SettlementValidations]
})

export class CodeInclusionComponent extends TaskHandler
  implements AfterContentInit, OnDestroy {


  filteredElements: UnitPriceDTO[] = [];
  elements: UnitPriceDTO[] = [];
  loaded = false;
  showLotes = false;

  lastPageFirstRecordIndex = 0;
  defaultNumberRows = 10;
  rowsPerPageOptions = [5, 10, 25, 50];

  model: CodeInclusionModel = new CodeInclusionModel();
  public windowHash: string;
  PRECIOSUNITARIOS_NUMDECIMALES = 2;
  tmpID = -999;
  public filterModel: UnitPricesFilterDTO;
  clonedElements: { [s: string]: UnitPriceDTO; } = {};
  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;


  constructor(
    private headerActionsService: HeaderActionsService,
    private propertyService: PropertyService,
  ) {
    super();
    this.windowHash = generateRandomIdentifier();
    this.subscribe(
      this.propertyService.getProperty('PRECIOSUNITARIOS_NUMDECIMALES', '4')
        .pipe(
          tap(value => {
            this.PRECIOSUNITARIOS_NUMDECIMALES = Number(value);
          }),
          catchError((error: any) => {
            return of(undefined)
          })
        )
    );
  }

  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.headerActionsService.clearActions();
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addAction(
        'Exportar',
        'fas fa-file-export',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.exportUnitPrice();
      });
    this.subscribe(this.headerActionsService
      .addAction(
        'Importar',
        'fas fa-file-import',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.importUnitPrice();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn-primary',
      true,
      this.windowHash
    ),
      success => {
        this.processTask();
      });
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ),
      success => {
        this.uiService.routeBack();
      });
    this.load();
  }

  private load(showWait = true): void {
    if (showWait) {
      this.waitService.startWaiting();
    }
    this.loaded = false;
    this.model = new CodeInclusionModel();
    this.model = JSON.parse(
      JSON.stringify(this.model, (k, v) => (k === '_parent' ? undefined : v))
    );
    this.model.dto = this.task.work['codeInclusion'];
    this.elements = this.model.dto.unitPrice;
    this.filteredElements = this.elements;
    this.model.ui = {
      awardDescription: '',
      contractDescription: '',
      taskProcurementProject: ProcurementProjectDTO.patchDTO(new ProcurementProjectDTO())
    }
    this.model.ui.taskProcurementProject = this.task.division.project;
    this.showLotes = this.model.ui.taskProcurementProject.breakdownLot.apportioned === true;
    this.setUIDescriptions();
    this.loaded = true;
    this.dtoToModel();
    if (showWait) {
      this.waitService.cancelWaiting();
    }
  }


  dtoToModel() {
    this.subscribe(this.createFormConfig1(),
      (form1: FormConfig) => {
        this.formConfig1 = form1;
      });

    this.formConfig1.functions.push({
      identifier: 'updateFilter',
      fn: this.updateFilter.bind(this)
    });
  }



  private createFormConfig1(): Observable<FormConfig> {
    this.filterModel = new UnitPricesFilterDTO();

    return of(new FormConfig(undefined,
      'codeinclusion/codeinclusion.json',
      this.filterModel
    ));
  }

  setUIDescriptions() {
    if (this.model.dto.award) {
      let award = this.model.dto.award;
      this.model.ui.awardDescription = award.contractNumber + '-' + (award?.description !== undefined ? award.description : '');
      this.model.ui.contractDescription = award.company.taxIdentifier +
        ((award?.company?.commercialName) ? (' - ' + award?.company?.commercialName) : '');
    }
  }

  public valueLotNumber(model: any) {
    return (model?.lot !== undefined && model.lot.lotNumber > 0) ? model.lot.lotNumber : '0';
  }

  public importUnitPrice() {
    let confirmMessage = '';
    if (this.model?.dto?.unitPrice && this.model?.dto?.unitPrice.length > 0) {
      confirmMessage = 'REEMPLAZAR eliminará los registros existentes en la tabla de precios unitarios y añadirá los registros del archivo Excel que seleccione a continuación';
    } else {
      confirmMessage = 'AÑADIR cargará los registros del archivo Excel seleccionado';
    }
    this.uiService.showConfirmMessage({
      message: confirmMessage,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.lastPageFirstRecordIndex = 0;
        this.subscribe(this.plycaService.getAction('IMPORT_UNITPRICE_FROM_EXCEL'), (datos: any) => {
          if (datos && datos.content) {
            let actionDefinition: ActionDefinitionDTO = datos.content[0];
            if (actionDefinition && actionDefinition.executableAction) {
              let action = actionDefinition.executableAction;
              action.parameters = action.parameters.filter(
                (param) => param.name !== 'TARGET'
              );
              let codeInclusion = CodeInclusionDTO.patchDTO(new CodeInclusionDTO());
              JSON.stringify(codeInclusion, (k, v) => (k === '_parent' ? undefined : v))

              codeInclusion.unitPrice = this.model.dto.unitPrice;
              if (this.task?.division !== undefined) {
                codeInclusion.division = this.task?.division;
              }
              codeInclusion = JSON.parse(
                JSON.stringify(codeInclusion, (k, v) => (k === '_parent' ? undefined : v))
              );
              codeInclusion.award = this.model.dto.award;
              action.target = codeInclusion;
              action.target.class = 'com.nexusit.plyca.api.userAPI.v1.codeInclusion.CodeInclusionDTO';

              let config: DynamicDialogConfig = {
                header: actionDefinition.executableAction.name,
                width: '70%',
                styleClass: 'actionStyle',
              };
              config['action'] = action;
              config['dto'] = actionDefinition.executableAction.target;
              config['runAction'] = true;

              const ref = this.dialogService.open(ActionsProcessComponent, config);
              this.subscribe(ref.onClose, (result: any) => {
                if (result && result.length) {
                  this.model.dto.unitPrice = [...result];
                  this.elements = this.model.dto.unitPrice;
                  this.filteredElements = [].concat(this.elements);
                  this.clearFilter();


                  let list = result.map(up => {
                    up.identifier = this.tmpID;
                    this.tmpID--;
                    return up
                  });
                  this.elements.splice(0);
                  this.elements.push(...list);
                  /*this.elements.forEach(
                    (up: UnitPriceDTO) =>
                      up['lotsArray'] = this.lotsArray);*/
                  this.clearFilter();
                  this.tmpID = 0;
                  this.filteredElements = [].concat(this.elements);
                }
              });
            }
          }
        });

      },
      reject: () => {
        console.log('NO SE IMPORTAN LAS EMPRESAS A INVITAR');
      }
    });
  }

  public exportUnitPrice() {
    this.subscribe(this.plycaService.getAction('EXPORT_UNITPRICE_TO_EXCEL'), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let action = actionDefinition.executableAction;
          action.parameters = action.parameters.filter(
            (param) => param.name !== 'TARGET'
          );
          let codeInclusion = CodeInclusionDTO.patchDTO(new CodeInclusionDTO());

          if (this.task?.division !== undefined) {
            codeInclusion.division = this.task?.division;
          }
          codeInclusion.unitPrice = this.elements;
          codeInclusion = JSON.parse(
            JSON.stringify(codeInclusion, (k, v) => (k === '_parent' ? undefined : v))
          );
          action.target = codeInclusion;
          action.target.class = 'com.nexusit.plyca.api.userAPI.v1.codeInclusion.CodeInclusionDTO';

          let config: DynamicDialogConfig = {
            header: actionDefinition.executableAction.name,
            width: '70%',
            styleClass: 'actionStyle',
          };
          config['action'] = action;
          config['dto'] = actionDefinition.executableAction.target;
          config['runAction'] = true;

          const ref = this.dialogService.open(ActionsProcessComponent, config);
          this.subscribe(ref.onClose, (result: any) => {
            if (result && result.length) {
              console.log('Importados precios unitarios' + this.elements.length);
              // this.formPlycaRef.updateView();
            }
          });
        }
      }
    });
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  onRowEditInit(item: any) {
    let cloned = lodash.cloneDeep(item);
    this.clonedElements[cloned.identifier] = { ...cloned };
  }


  public _getSimpleIdentifierFromString(identifier) {
    return getSimpleIdentifierFromString(identifier);
  }


  public clearFilter(): void {
    this.filterModel.code = '';
    this.filterModel.description = '';
    this.filterModel.group = '';
    this.updateFilter(this.elements);
  }

  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    // config.fieldStyle = 'col-12 col-md-4';
    config.jsonField = name;
    config.type = 'TEXT';
    config.maxlength = 40;
    return config;
  }

  onRowEditCancel(item: UnitPriceDTO, index: number) {
    this.clearFilter();
    this.elements[index] = this.clonedElements[item.identifier];
    this.filteredElements = this.elements;
    delete this.clonedElements[item.identifier];
  }

  onRowEditSave(item: UnitPriceDTO, index: number) {
    if (!item.internalCode || item.internalCode === ''
    ) {
      this.onRowEditCancel(item, index);
      this.uiService.showMessage('Se deben cumplimentar los campos requeridos: Código Interno.',
        this.translateService.instant('General.error'));

    } else {
      delete this.clonedElements[item.identifier];
      this.uiService.showSuccess(
        this.translateService.instant('General.msg.updateok'),
        this.translateService.instant('General.info'),
        'success'
      );

    }
  }

  /*public updateFilter(model: any) {
    if ((!model.code || model?.code === '')
    ) {
      this.filteredElements = [].concat(this.elements);
    } else {

      this.filteredElements = this.elements.filter((item: UnitPriceDTO) => {

        let valid =
          ((!model.code || model.code === '') || item.internalCode.toLowerCase().indexOf(model.code.toLowerCase()) !== -1);


        return valid;
      }
      );
    }

  }*/


  public updateFilter(model: any) {
    if ((!model.description || model?.description === '')
      && (!model.code || model?.code === '')
      && (!model.group || model?.group === '')
    ) {
      this.filteredElements = [].concat(this.elements);
    } else {

      this.filteredElements = this.elements.filter((item: UnitPriceDTO) => {
        let valid =
          ((!model.description || model?.description === '' || model.description === undefined)
            || (item.description !== undefined && item.description.toLowerCase().indexOf(model.description.toLowerCase()) !== -1))
          &&
          ((!model.code || model?.code === '' || model.code === undefined)
          || (item.internalCode !== undefined && item.internalCode.toLowerCase().indexOf(model.code.toLowerCase()) !== -1))
          &&
          ((!model.group || model?.group === ''
             || model.group === undefined)
             || (item.group !== undefined && item.group.toLowerCase().indexOf(model.group.toLowerCase()) !== -1));


        return valid;
      }
      );
    }
  }

  onPageChange(event: any) {
    this.lastPageFirstRecordIndex = event.first;
    this.defaultNumberRows = event.rows;
  }

  gotoLastPage(gotoLastPage: boolean) {
    if (gotoLastPage) {
      // Accede al número total de registros de la tabla

      let totalRecords = this.elements?.length;
      // Establece el primer índice para la última página

      const totalPages = Math.ceil(totalRecords / this.defaultNumberRows);
      this.lastPageFirstRecordIndex = (totalPages) * this.defaultNumberRows;

    }
  }
}
